// src/constants/projetos.js

export const PROJETOS_TABELA_NORMAL = [
  "IPAAM - SISLAM",
  "SAMARCO - CAR MG",
  "VALMONT - AGROPULSE",
  "VLI - ALOCAÇÃO",
  "SUZANO - INVENTÁRIO",
  "SDA BA - SICARF",
  "DATAPREV - CAR",
  "MONSANTO - BAYER",
  "SEMA AM - ANÁLISE",
  "SEMA AM - BASE",
  "IMAGEM - COOPERAÇÃO COMERCIAL",
  "MUNICH RE EUA - ALOCAÇÃO",
  "SUZANO - REGAM",
  "GT4W - ALOCAÇÃO VEGA",
  "IICA - ANÁLISE PA",
  "IICA - ANÁLISE RO",
  "VALMONT - DESENVOLVIMENTO MOBILE",
  "MUNICH RE BRA - ALOCAÇÃO",
  "IAT PR - CAR",
  "IICA - PRADA PA",
  "SUZANO - MRA",
  "SERPRO - DESENVOLVIMENTO",
  "SEPAT RO - SICARF",
  "VEGA - VISTORIA REMOTA",
  "BRACELL - CONVERSÕES",
  "FEST - ICMBIO",
  "IICA - BASES PA",
  "ARAPYAÚ - PLATAFORMA DO CACAU",
  "FBDS/NORAD - CAR DPG",
  "IICA/SEMAS - RETIFICAÇÃO",
  "GIZ - FUNAI",
  "FEST - MDA",
  "ITERMA - SICARF",
  "ITERPA - SICARF",
  "FEST - ICS",
  "ITESP - SICARF",
  "COFFEE BREAK",
  "TNC",
  "Árvore",
  "RATEIO DE OPERAÇÕES",
  "NEOXS - PREDI",
  "Seu Lugar",
  "CONFRA 2025",
  "GIZ FLORESTA +",
  "IMAGEM - ANATER",
  "LUNDIN MINING/SEMAD GO - INÃ",
  "SEU LUGAR",
  "VALMONT - CUSTOMIZAÇÕES",
  "TNC - ARRECADAÇÃO PA",
  "SEMA AM - ANÁLISES",
  "TELEBRAS - HABILITAÇÃO",
  "SERPRO - HABILITAÇÃO",
  "AMAPÁ TERRAS - SICARF",
  "FUNBIO - ITERPA"
];

export const CUSTOS_PROJETOS = {
  Bayer: 208.35,
  IAT: 108473.28,
  Dataprev: 84642.39,
  IAT_2: 75980.52,
  IICA: 29748.73,
  Norad: 105741.42,
  Valmont: 784.54,
  Bracell: 9978.02,
  ICMBio: 59424.06,
  IICA_2: 6113.75,
  IICA_3: 45266.09,
  IICA_4: 6958.9,
  IICA_5: 2692.02,
  ITERPA: 10555.69,
  "Projeto AM - Análise": 65309.24,
  "Projeto AM - Base": 16923.06,
  SUZANO_1: 9402.11,
  SUZANO_2: 7825.73,
  SUZANO_3: 7002.33,
  SUZANO_4: 18177.38,
  ITERPA_2: 0,
  GIZ: 0,
  IPAAM: 69495.53,
  MDA: 91961.46,
  NEOXS: 7353.79,
  SEDAP: 3543.16,
  SERPRO: 60734.87,
  VLI: 34700.94,
  "Amapá Terras": 2870.21,
  Iterma: 33204.04,
  ITERPA_3: 90382.27,
  SEPAT: 58148.42,
  "Sicarf - Bahia": 1324.95,
  Arapyaú: 15703.72,
  GIZ_2: 11605.54,
  Munich: 19177.99,
  SEMAD: 2365.04,
  "Seu Lugar": 1104.23,
  "Floresta + Sustentavel": 0,
  "Projeto Árvore": 0
};

export const MAPA_MESES_2025 = {
  Janeiro: 1,
  Fevereiro: 2,
  Março: 3,
  Abril: 4,
  Maio: 5,
  Junho: 6,
  Julho: 7,
  Agosto: 8,
  Setembro: 9,
  Outubro: 10,
  Novembro: 11,
  Dezembro: 12
};


 export const CUSTOS_PROJETOS_2026 = {
  "IPAAM - SISLAM": 53822.25,
  "NEOX - PREDI": 4045.77,
  "SERPRO - DESENVOLVIMENTO": 94053.79,
  "FEST - MDA": 157880.85,
  "ANATER": 12536.83,
  "FEST - ICS": 2039.45,
  "ITERMA - SICARF": 41286.46,
  "ITERPA - SICARF": 138172.43,
  "ITESP - SICARF": 9444.00,
  "SEPAT RO - SICARF": 16607.21,
  "SAMARCO - CAR MG": 151179.73,
  "FEST - ICMBIO": 63858.36,
  "IAT PR - CAR": 75916.07,
  "DATAPREV - CAR": 89627.46,
  "IICA - ANÁLISE RO": 62426.75,
  "IICA - ANÁLISE PA": 19711.20,
  "IICA - BASES PA": 27456.95,
  "IICA - PRADA PA": 6365.13,
  "IICA/SEMAS - RETIFICAÇÃO": 7536.18,
  "ARAPYAÚ - PLATAFORMA DO CACAU": 6046.70,
  "VALMONT - AGROPULSE": 11540.35,
  "VALMONT - CUSTOMIZAÇÕES": 0.00,
  "SUZANO - INVENTÁRIO": 14041.69,
  "SUZANO - REGAM": 25938.33,
  "SUZANO - MRA": 636.78,
  "SUZANO CAR TERCEIROS": 0.00,
  "SEMA AM - ANÁLISE": 38223.11,
  "SEMA AM - BASE": 6282.52,
  "LUNDIN MINING/SEMAD GO - INÃ": 6973.73,
  "VEGA - VISTORIA REMOTA": 2029.27,
  "MUNICH RE BRA - ALOCAÇÃO": 0.00,
  "MUNICH RE EUA - ALOCAÇÃO": 18118.78,
  "FBDS/NORAD - CAR DPG": 99262.83,
  "MONSANTO - BAYER": 2664.20,
  "GIZ - FUNAI": 14890.14,
  "ÁRVORE": 0.00,
  "GIZ - FLORESTA +": 0.00,
  "SDA BA - SICARF": 2967.39,
  "SEU LUGAR": 2981.54,
  "TNC - ARRECADAÇÃO PA": 0.00
};

